import { Injectable } from "@angular/core";
import * as CONSTANTS from './shared/constants';
import { Router } from '@angular/router';
import { CookiesService } from 'src/app/cookies.service';

@Injectable()
export class AppService {
  constructor(private _router: Router) {}
  
  public checkCurrentSessesion() {
    if ( CookiesService.getItem(CONSTANTS.USER_DATA)) {
      const currentUser = JSON.parse( CookiesService.getItem(CONSTANTS.USER_DATA));
      if (currentUser.isAdmin) {
        CookiesService.removeItem(CONSTANTS.USER_DATA);
        CookiesService.removeItem(CONSTANTS.USER_INFO);
        CookiesService.removeItem(CONSTANTS.USER_TOKEN);
        this._router.navigate(['']);
      }
    } else {
    }
  }
}
